module.exports = __webpack_public_path__ + "static/media/0014.0a41b7bc.jpg";